import Swiper from 'swiper/bundle';
import EffectMaterial from '../../vendors/effect-material.esm.js';
import { animate, inView, stagger } from "motion";

document.addEventListener('DOMContentLoaded', function () {
    const componentCarousels = document.querySelectorAll('.block-carousel');

    if (componentCarousels.length === 0) return;

    componentCarousels.forEach(componentCarousel => {
        const componentCarouselSwiper = componentCarousel.querySelector('.block-carousel__swiper');

        // Initialize Swiper
        const swiperInstance = new Swiper(componentCarouselSwiper, {
            // Pass EffectMaterial module to modules
            modules: [EffectMaterial],
            effect: 'material',
            // Material effect parameters
            materialEffect: {
                slideSplitRatio: 1,
            },
            grabCursor: true,
            spaceBetween: 20,
            speed: 600,
            loop: true,
            slidesPerView: 2, // Default to 4 slides at a time
            navigation: {
                nextEl: componentCarousel.querySelector('.swiper-button-forward'),
                prevEl: componentCarousel.querySelector('.swiper-button-previous'),
            },
            pagination: {
                el: componentCarousel.querySelector('.swiper-pagination'),
                clickable: true,
            },
            breakpoints: {
                // When the viewport width is more than or equal to 768px
                768: {
                    slidesPerView: 2, // Show 1.5 slides at a time
                    materialEffect: {
                        slideSplitRatio: 0.5,
                    },
                },
            },
        });

        const componentCarouselSwiperSlides = componentCarouselSwiper.querySelectorAll('.swiper-slide');

        // Apply animation to each swiper slide with the fade-up class
        inView(componentCarouselSwiper, () => {
            animate(componentCarouselSwiperSlides, 
                { 
                    opacity: [0, 1], // Fade in (opacity transition from 0 to 1)
                    transform: ['translateY(60px)', 'translateY(0)'], // Slide up (translateY transition)
                },
                { 
                    duration: 0.6, // Animation duration
                    delay: stagger(0.125, { startDelay: 0.3 }) // Delay before animation starts.
                }
            );
        });
    });
});